import request from '@/utils/request'
import axios from 'axios'

// 列表数据
export function fetchList(params) {
  return request({
    url:'/notice/list',
    method:'get',
    params:params
  })
}

// 更新状态
export function noticeUpdate(params) {
  return request({
    url:'/notice/update',
    method:'post',
    params:params
  })
}

// 根据id获取数据
export function getForm(id) {
  return request({
    url:'/notice/form/'+id,
    method:'get',
  })
}

// 获取维度条数
export function getUnReadNum() {
  return request({
    url:'/notice/findNum',
    method:'get',
  })
}




// WEBPACK FOOTER //
// ./src/api/notice.js